import { Card, Typography, Grid, Box } from '@mui/material';
import formatMoney from 'src/utils/formatMoney';

function Tile({ label, value, hint, onClick, color }) {
  return (
    <Card
      onClick={onClick}
      sx={{
        p: 2, height: '100%',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'box-shadow .15s',
        '&:hover': onClick ? { boxShadow: 6 } : {},
      }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.6 }}>
        {label}
      </Typography>
      <Typography variant="h4" fontWeight={700} sx={{ mt: 0.5, color: color || 'text.primary' }}>
        {value}
      </Typography>
      {hint ? <Typography variant="body2" color="text.secondary">{hint}</Typography> : <Box sx={{ height: 20 }} />}
    </Card>
  );
}

// Money headline (reading order: top). Money tiles pass currency_id so their drill
// TCV sums reconcile with the tile; count tiles omit currency_id (FR-025 / SC-005).
export default function KpiBand({ kpi, currencyId, currencyLabel, openDrill }) {
  if (!kpi) return null;
  const winRate = kpi.win_rate === null || kpi.win_rate === undefined
    ? '—' : `${(kpi.win_rate * 100).toFixed(1)}%`;
  const cycle = kpi.avg_sales_cycle_days === null || kpi.avg_sales_cycle_days === undefined
    ? '—' : `${kpi.avg_sales_cycle_days} d`;

  const tiles = [
    {
      label: 'Open TCV', value: formatMoney(kpi.open_tcv, currencyLabel),
      onClick: () => openDrill({ lifecycle: 'open', currency_id: currencyId }, 'Open pipeline'),
    },
    {
      label: 'Won TCV', value: formatMoney(kpi.won_tcv, currencyLabel), hint: `${kpi.won_count} won`,
      onClick: () => openDrill({ lifecycle: 'won', currency_id: currencyId }, 'Won deals'),
      color: 'success.main',
    },
    { label: 'ARR', value: formatMoney(kpi.arr, currencyLabel) },
    { label: 'MRR', value: formatMoney(kpi.mrr, currencyLabel) },
    {
      label: 'Active Deals', value: kpi.active_deals,
      onClick: () => openDrill({ lifecycle: 'active' }, 'Active deals'),
    },
    {
      label: 'New Deals', value: kpi.new_deals, hint: 'in period',
      onClick: () => openDrill({ lifecycle: 'new' }, 'New deals'),
    },
    { label: 'Win Rate', value: winRate, hint: `${kpi.lost_count} lost` },
    { label: 'Avg Sales Cycle', value: cycle },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {tiles.map((t) => (
        <Grid item xs={6} sm={4} md={3} key={t.label}>
          <Tile {...t} />
        </Grid>
      ))}
    </Grid>
  );
}
